import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox';
import moment from 'moment';
import { isEqual } from 'lodash';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import {
  updatePhase,
  updatePhaseTask,
} from 'actionCreators/phase';
import PhaseType from 'types/phase';
import { RAILS_DATE } from 'config/constants';
import S from './styles.scss';
import WarehouseMaterials from '../../tabs/warehouseMaterials';
import { requestPhaseItems, savePhaseItem } from 'actionCreators/phase_items';
import ColoredButton from 'components/ColoredButton';

const LINE_ITEM_TYPE = 'warehouseMerchandiseItems';

class PhaseMaterialsChecklist extends React.Component {

  constructor(props) {
    super(props);
    this.handleLineItemChange = this.handleLineItemChange.bind(this);
    const { phase, phase: { phase_specific: { need_move_furniture } },
      merchItems } = this.props;
    this.state = {
      phase,
      originalFurnitureStatus: need_move_furniture,
      merchItems,
      noteId: null,
      active: false,
      showErrorMessage: false,
    };
  }

  componentWillMount = () => this.props.requestPhaseItems(this.props.params.id, 'warehouseMerchandiseItems');

  componentDidUpdate = prevProps => ((!isEqual(prevProps.merchItems, this.props.merchItems)) ?
    this.setState({ merchItems: this.props.merchItems }) : null);

  handleLineItemChange = (key) => {
    const editedItemList = this.state.merchItems.map((i) => {
      const editedItem = i;
      if (i.id === key) {
        editedItem.date_received = !i.date_received ? moment().format(RAILS_DATE) : null;
      }
      return editedItem;
    });
    this.setState({ merchItems: editedItemList });
  }

  handleTextNote = (e, key) => {
    const note = e.target.value;
    const editedItemList = this.state.merchItems.map((i) => {
      const editedItem = i;
      if (i.id === key) editedItem.note = note;
      return editedItem;
    });
    this.setState({ deliveryNote: editedItemList });
  }

  showNoteModal = id => this.setState({ noteId: id, active: true });

  hideNoteModal = () => this.setState({ active: false, noteId: null });

  releaseItems = items => items.map((i) => {
    const editedItem = i;
    editedItem.status = i.date_received ? 'Released' : i.status;
    return editedItem;
  });

  navigateToHistory = phase => this.props.navigate(urls.phaseHistory(phase));

  handleChecklistSubmit = () => {
    const { merchItems, phase, phase: { id } } = this.state;
    const filterForUncheckedItems =
      this.state.merchItems.filter(i => (!i.date_received && !i.note));
    if (filterForUncheckedItems.length > 0) this.setState({ showErrorMessage: true });
    else {
      Promise.all(this.releaseItems(merchItems).map(i =>
        this.props.savePhaseItem(this.state.phase.id, i, LINE_ITEM_TYPE)))
          .then(() => this.props.updatePhaseTask(id, 'check_out_of_store', {
            task: { status: 'complete' } })).then(() => this.navigateToHistory(phase))
          .catch(() => {});
    }
  }

  render = () => {
    const { showErrorMessage, active, merchItems, noteId } = this.state;
    return (<div>
      <div className={S.submitBtnContainer}>
        <h4 className={S.checklistHeading}>Material Checklist</h4>
        <ColoredButton
          id="checklistSubmitBtn"
          color="red"
          responsive
          label="Submit"
          className="d-none"
          onClick={this.handleChecklistSubmit}
        />
      </div>
      <p style={{ textAlign: 'center', color: 'red' }}>
        { showErrorMessage ? 'All items must be checked or a note must be provided prior to submitting.' : '' }
      </p>
      <table style={S.table}>
        <thead>
          <tr>
            <th>Item Description</th>
            <th>Received</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          {merchItems.map(item => (<tr key={item.id}>
            <td>{`${item.item_name}`} <br /> {`(Qty: ${item.received_quantity})`}</td>
            <td>
              <input
                id="mainInput"
                type="checkbox"
                checked={!!item.date_received}
                onChange={() => this.handleLineItemChange(item.id)}
              />
            </td>
            <td>
              <button onClick={() => this.showNoteModal(item.id)}>Add Note</button>
            </td>
          </tr>))}
        </tbody>
      </table>
      <Dialog
        active={(active && noteId)} className={S.modal} type="large"
        onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
      >
        <h5>Note</h5>
        <div>
          <div>
            <textarea
              rows={6} style={{ width: '100%' }}
              onChange={() => this.handleTextNote(event, noteId)}
            />
          </div>
          <ColoredButton
            color="blue"
            responsive
            label="Done"
            className="d-none"
            onClick={this.hideNoteModal}
          />
        </div>
      </Dialog>
    </div>);
  }
}

PhaseMaterialsChecklist.propTypes = {
  phase: PhaseType.isRequired,
  merchItems: PropTypes.array,
  role: PropTypes.string.isRequired,
  user: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
  updatePhase: PropTypes.func.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  requestPhaseItems: PropTypes.func,
  savePhaseItem: PropTypes.func,
  params: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const mapStateToProps = (state) => {
  const { phase: { details = {}, warehouseMerchandiseItems = { items: [] } },
    user: { name, role } } = state;
  const { items } = warehouseMerchandiseItems;
  return {
    phase: details,
    user: name,
    role,
    merchItems: items.length ? items.filter(item => !!item.item_name) : [],
  };
};

export default connect(
  mapStateToProps, {
    navigate,
    updatePhase,
    updatePhaseTask,
    WarehouseMaterials,
    requestPhaseItems,
    savePhaseItem,
  },
)(PhaseMaterialsChecklist);




// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseMaterialsChecklist/index.jsx